module.exports = __webpack_public_path__ + "static/media/HMA Polinema.53094674.png";